import React from 'react';
import { ArrowBack } from '@mui/icons-material';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';

interface Props {
  label: string;
  onRedirect?: VoidFunction;
  redirectTooltip?: string;
}

export const CardTitle = ({ label, onRedirect, redirectTooltip = 'Go to VO details' }: Props) => {
  return (
    <Stack direction="row" alignItems="center" gap="0.5rem">
      <Tooltip title={redirectTooltip}>
        <IconButton sx={{ padding: 0 }} onClick={onRedirect}>
          <ArrowBack sx={{ color: ({ palette }) => palette.common.black }} />
        </IconButton>
      </Tooltip>

      <Typography variant="h5" fontWeight={500}>
        {label}
      </Typography>
    </Stack>
  );
};
